// Store data with timestamp
export function setExpiringSessionData(key, data) {
    const dataToStore = {
        data: data,
        timestamp: new Date().getTime()  // Current timestamp in milliseconds
    };
    try {
      sessionStorage.setItem(key, JSON.stringify(dataToStore));
    } catch {
      console.log("data too large to store");
    }
}

// Retrieve data and check timestamp
export function retrieveExpiringSessionData(key, expirationLimitInMinutes) {
    const dataFromStorage = JSON.parse(sessionStorage.getItem(key));
    if (dataFromStorage) {
        const now = new Date().getTime();
        const expirationLimit = expirationLimitInMinutes * 60 * 1000;  // Convert minutes to milliseconds
        if (now - dataFromStorage.timestamp > expirationLimit) {
            // Data is older than expiration limit, invalidate it
            sessionStorage.removeItem(key);
            return null;
        } else {
            // Data is valid, return it
            return dataFromStorage.data;
        }
    } else {
        // No data found for the key
        return null;
    }
}
export function setExpiringSessionDataWithId(key, data, id) {
    let existingData = {};
    try {
        const stored = sessionStorage.getItem(key);
        if (stored) {
            existingData = JSON.parse(stored);
        }
    } catch {
        existingData = {};
    }
    
    existingData[id] = {
        data: data,
        timestamp: new Date().getTime()
    };
    
    try {
      sessionStorage.setItem(key, JSON.stringify(existingData));
    } catch {
      console.log("data too large to store");
    }
}
// Retrieve data, check timestamp, and check id
export function retrieveExpiringIndexedSessionData(key, expirationLimitInMinutes, targetId) {
    try {
        const allData = JSON.parse(sessionStorage.getItem(key));
        if (allData && allData[targetId]) {
            const itemData = allData[targetId];
            const now = new Date().getTime();
            const expirationLimit = expirationLimitInMinutes * 60 * 1000;
            if (now - itemData.timestamp > expirationLimit) {
                // Data is expired, remove only this item
                delete allData[targetId];
                sessionStorage.setItem(key, JSON.stringify(allData));
                return null;
            } else {
                // Data is valid, return it
                return itemData.data;
            }
        }
        return null;
    } catch {
        return null;
    }
}

// Remove data from session storage if it matches the target ID
export function removeExpiringIndexedSessionData(key, targetId) {
    try {
        const allData = JSON.parse(sessionStorage.getItem(key));
        if (allData && allData[targetId]) {
            delete allData[targetId];
            if (Object.keys(allData).length === 0) {
                sessionStorage.removeItem(key);
            } else {
                sessionStorage.setItem(key, JSON.stringify(allData));
            }
            return true; // Data was found and removed
        }
        return false; // No matching data found
    } catch {
        return false;
    }
}